import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ThreadError } from '@/exceptions/thread/thread.enum';
import { threadService } from '@/services/thread.service';

const useChangeThreadStatus = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			threadId,
			status,
		}: {
			threadId: number;
			status: string;
		}) => await threadService.changeThreadStatus(threadId, status),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['thread'] });
		},

		onError: () => {
			throw new Error(ThreadError.CHANGE_STATUS_ERROR);
		},
	});
};

export default useChangeThreadStatus;
